import React, { useContext } from 'react';
import { Badge } from 'react-bootstrap';
import DealContext from './DealContext';

const SimpleQuoteLink = ({ quote, ...rest }) => {
  const {
    presentQuote,
  } = useContext(DealContext);

  if (!quote) {
    return null;
  }

  const handleClick = (event) => {
    event.stopPropagation();

    if (presentQuote) {
      presentQuote(quote.id);
    }
  };

  const label = `Q${String(quote.id)}`;

  return (
    <Badge onClick={handleClick} {...rest} style={{ border: '1px solid #CCC', backgroundColor: '#fafafa', padding: '5px', cursor: 'pointer' }}>
      <i className="fas fa-circle mr-1" style={{ color: quote.QuoteState.color }} title={quote.QuoteState.name} />
      {label}
    </Badge>
  );
};

export default SimpleQuoteLink;
